<template>
	<footer class="footer">
		<div class="block-wrap grid">
			<div class="firstCol">
				<!-- <h6>Made with love by</h6> -->
	
<!-- 				<a href="http://normcore.io/discord"><i class="fab fa-discord"></i></a>
				<a href="https://www.twitter.com/normalvr"><i class="fa fa-twitter"></i></a>
				<a href="https://www.instagram.com/normalvr/"><i class="fa fa-instagram"></i></a>
				<a href="https://medium.com/@normalvr"><i class="fab fa-medium-m"></i></a> -->
				<!-- <h6 class="wemake">Things we make</h6> -->
<!-- 				<div class="make-group">	
					<div class="make-entry make-halfhalf"><a href="http://halfhalf.fun"><img src="/img/halfhalflogowhite.svg" alt=""></a></div>
					<div class="make-entry make-normcore"><a href="http://normcore.io">Normcore.</a></div>
					<div class="make-entry make-normalchat"><a href="https://www.normalvr.com/">Normal<span>Chat</span></a></div>
				</div>
 -->
			</div>
		<!-- 	<ul>
				<h6>Normcore</h6>
				<li><a href="gettingstarted.html">Getting Started</a></li>
				<li><a href="documentation.html">Documentation</a></li>
				<li><a href="pricing.html">Pricing</a></li>
				<li><a href="enterprise.html">Enterprise</a></li>
				<li><a href="enterprisesupport.html">Support</a></li>
				<li><a href="https://normcore.io/dashboard">Login</a></li>
			</ul>
			<ul>
				<h6>Other</h6>
				<li><a href="https://www.normalvr.com/about/">About Normal</a></li>
				<li><a href="https://www.normalvr.com/jobs/">Jobs</a></li>
				<li><a href="https://www.halfhalf.fun">Half + Half</a></li>
				<li><a href="creatorprogram.html">Creator Program</a></li>
				<li><a href="launchprogram.html">Launch Program</a></li>

			</ul> -->
		</div>
		<div class="row middle-xs">
			<div class="col-sm-10  mini-nav">
				<a href="https://normcore-test.now.sh/8c6ca234d4b758c8e4cd0924b9284b8cd7b28291/">Normcore.io</a> |
				<a href="https://normcore-test.now.sh/8c6ca234d4b758c8e4cd0924b9284b8cd7b28291/gettingstarted">Getting Started</a>
				<a href="https://normcore-test.now.sh/8c6ca234d4b758c8e4cd0924b9284b8cd7b28291/pricing">Pricing</a>
				<a href="https://normcore-test.now.sh/8c6ca234d4b758c8e4cd0924b9284b8cd7b28291/enterprise">Enterprise</a>
				<a href="https://normcore-test.now.sh/8c6ca234d4b758c8e4cd0924b9284b8cd7b28291/enterprisesupport">Support</a>
			</div>
			<div class="logo col-sm-2">
				<a href="https://www.normalvr.com/"><img src="/img/normal-logo.svg" alt="Normal."></a>
			</div>			
		</div>
		<div class="row">
			<div class="col-xs-12">
				<div class="copyright">
					<div class="rightAnchor">+++</div>
					<div>© 2020 Normal Inc. Brooklyn, NY. </div>
				</div>	
			</div>
		</div>
	</footer>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

/*Footer*/

footer {
	/*height: 50vh;*/
	position: relative;
	overflow: hidden;

	/*display: flex;*/
	justify-content: space-between;
	// background-color: black;
	transition: color 0.35s ease-out, background-color 0.35s ease-out;
	/*background-color: var(--yellow);*/
	// /*color: black;*/
	margin-top: 10vh;
	margin-bottom: 8px;
}

footer a {
	text-decoration: none;
}
footer .grid {
	flex: 1;
	grid-template-columns: 2fr 1fr 0.5fr;
	grid-column-gap: 1rem;
	align-content:end;
	margin-block-end:6px;
	margin-block-start:50px;

}

footer li {
	margin-bottom: 1.5em;
	font-size: clamp(13px, 1vw, 20px);

}
footer ul {
	/*margin-top: 6em;*/
}
footer .logo {
	font-size: 2.1em;
	font-weight: bold;
	font-family: "Platform";
	opacity: 0.7;
	text-align: right;
	a {
		justify-content: flex-end;
		display: flex;
	}

}
footer .logo img {
	max-width: 60px;
	transition: filter .35s ease-out;

}

footer i {
	margin-top:1em;
	margin-right:1.5em;
	font-size: 16px;
}
footer h6 {
	margin-bottom: 30px;
	/*margin-left: -30px;*/
}
.mini-nav {
	font-size:  0.9em;
	a {
		padding: 0 10px;
	}
	a:nth-child(1) {
		padding-left: 0;
	}
}

.wemake { 
	margin-top: 40px;
	margin-bottom: 10px;
 }

.make-group {
	margin-top: 20px;
	display: flex;
	font-size: 20px;
	align-items: center;
}
.make-normcore {
	font-weight: 800;
	font-family: "Platform";
}

.make-normalchat {
	font-weight: 800;
	font-family: "Platform";
}

.make-normalchat span {
	font-weight: 100;
}

.make-halfhalf {
	width: 48px;
	transition: filter .35s ease-out;
	filter: invert(1);
}
.make-entry {
	/*padding: 20px;*/
	margin-right: 20px;
}

.copyright {
    display: block;
    font-size: 9px;
    text-transform: uppercase;
    letter-spacing: 3px;
    // margin-top:20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
}


// footer:hover {
// 	background-color: var(--yellow);
// 	color: black;
// }

footer:hover .logo img {

}

footer:hover .make-halfhalf {
	// filter: invert(1);
}

.rightAnchor {
    font-size: 14px;
    align-self: flex-start;
    letter-spacing: 12px;
    font-weight: 100;
}

@media (max-width: 600px) {
	footer {

	}
	footer h6 { 
		display: none;
	}
	footer .grid {
		grid-template-columns: 1fr 1fr;
		align-content:end;
		margin:0;
		/*margin-block-end:50px;*/
	}
	footer ul {
		margin-top: 0em;
	}
	footer li {
		 margin-bottom: 1em;
	}
	footer .firstCol {
		/*grid-column-start: 1*/
		margin-bottom: 1.5em;
		font-size: 1.7em;
		grid-column-start: 1;
    	grid-column-end: 3;

	}
}

h6 {
	/*font-size: 0.5rem;*/
	font-size: clamp(8px, 0.5vh, 26px);
	margin: 0 0;
	font-weight: 400;
	text-transform: uppercase;
	letter-spacing: 2px;
}
</style>
